var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('static-tabs-wallet',{attrs:{"active":"registries"}}),_vm._v(" "),_c('registries')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }